import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-158" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-4xl" data-id="element-159" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-160" data-mp="2w5yfx5viwj5p">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-161" data-mp="2w4wxuhg3aweh">
            Ti riconosci in queste situazioni?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-162" data-mp="2m93fuijlqapb">
            Se hai risposto sì almeno una volta, questo pacchetto è per te.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-163" data-mp="2d7m4fdh52x6y">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-164" data-mp="28anaow1e0s9a">
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-165" data-mp="6gwd24s7pk8u" />
                <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-166" data-mp="3jjsij938fdyt">
                  {item.text}
                </span>
              </li>;
        })}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-167" data-mp="39oh0agsm7omb">
          Ti meriti molto più di questo →
        </p>
      </div>
    </section>;
}